import { render } from 'preact';
import { App } from './ui/App.tsx';
import { installMobileBlankDoubleTapGuard } from './ui/mobile-double-tap-guard.ts';
import './styles.css';
import './styles/phase-7b.css';
import './styles/phase-9-6.css';

const root = document.querySelector<HTMLDivElement>('#app');
if (!root) throw new Error('Buncha Coasters app root is missing.');
const removeMobileBlankDoubleTapGuard = installMobileBlankDoubleTapGuard();
render(<App />, root);

if (import.meta.hot) {
  import.meta.hot.dispose(removeMobileBlankDoubleTapGuard);
}
